// extracted by mini-css-extract-plugin
export default {"slide":"LoanAmount_slide__CLpFw","slideWrapper":"LoanAmount_slideWrapper__N+7W4","slideHeading":"LoanAmount_slideHeading__DSFG2","btnBox":"LoanAmount_btnBox__9F33O"};